/* @flow */

export enum ParentalGuidanceRatingSystem {
  BBFC = 'BBFC',
  Default = 'default',
  IFCO = 'IFCO',
  PEGI = 'PEGI',
  USA_PR = 'USA_PR',
}

export type NETGEM_API_V8_PARENTAL_GUIDANCE_RATING = {
  label?: string,
  minimumAge?: number,
  system: ParentalGuidanceRatingSystem,
};

export type NETGEM_API_V8_PARENTAL_GUIDANCE = {
  adult?: boolean,
  label?: string,
  minimumAge: number,
  ratings?: Array<NETGEM_API_V8_PARENTAL_GUIDANCE_RATING>,
};
